// CSS do ANTD foi incluída aqui para não causar maiores problemas no CSS da aplicacao.
import 'antd/lib/cascader/style/css';
import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import './util/yup-locale-pt-br';

import App from './App';
import { Sentry } from 'service/Sentry';
import reportWebVitals from './reportWebVitals';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration)
dayjs.locale('pt-br')


Sentry.instance.initialize();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
